﻿import {StringNamedValue} from "@2d-front-monorepo/core";
import React, {JSX, useMemo, useRef} from "react";
import Checkbox from "./Checkbox";
import Radio from "./Radio";
import {useArrayOnChange} from "./useArrayOnChange";
import {useSelected} from "./useSelected";

export type OptionListEntry = StringNamedValue & {
	disabled?: boolean;
}

export type OptionListProps = {
	name: string,
	values: string[],
	items: OptionListEntry[];
	column?: string,
	disabled?: boolean;
	hidden?: boolean;
	onChange?: (values: number[]) => void;
	ref?: React.RefObject<HTMLDivElement | null>;
	multiple?: boolean;
};

export default function OptionList(props: OptionListProps): JSX.Element {
	const {
		name,
		values,
		items,
		column,
		hidden,
		disabled,
		onChange,
		ref,
		multiple
	} = props;

	const klass = useMemo(() => "option-list" + (column ? ` ${column}` : ""), [column]);
	const innerRef = ref ?? useRef<HTMLDivElement>(null);

	const selected = useSelected(values, multiple);
	const internalOnChange = useArrayOnChange(innerRef, onChange);

	if (hidden) {
		return <></>;
	}

	if (multiple) {
		return <div className={klass} ref={innerRef}>
			{items.map((item, index) => <Checkbox
				label={item.label}
				value={item.value}
				key={index}
				name={name}
				checked={selected(item.value)}
				disabled={disabled || item.disabled}
				onChange={internalOnChange}/>)}
		</div>;
	}

	return <div className={klass} ref={innerRef}>
		{items.map((item, index) => <Radio
			label={item.label}
			value={item.value}
			key={index}
			name={name}
			checked={selected(item.value)}
			disabled={disabled || item.disabled}
			onChange={internalOnChange}/>)}
	</div>;
};
